module.exports.get = function () {

  function urlMethod(cb){
    fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyD7I-CM6G3BPSZG_jp6YJA6ctpB2Ie5844', {
      method: 'post',
    })
    .then((response) => response.json())
    .then(function (pos) {
      

      cb(false,JSON.parse(JSON.stringify({
        coords: {
          latitude: pos.location.lat,
          longitude: pos.location.lng,
          accuracy: pos.accuracy,
        }
      })))

     })
     .catch(function(err) {
       cb(true,err)
     })

  }
  // await checkEnableWifi()
  return new Promise(((resolve, reject) => {
    navigator.geolocation.getCurrentPosition( function (position) {
      const positionObject = {};
      if ('coords' in position) {
        positionObject.coords = {};

        if ('latitude' in position.coords) {
          positionObject.coords.latitude = position.coords.latitude;
        }
        if ('longitude' in position.coords) {
          positionObject.coords.longitude = position.coords.longitude;
        }
        if ('accuracy' in position.coords) {
          positionObject.coords.accuracy = position.coords.accuracy;
        }
        if ('altitude' in position.coords) {
          positionObject.coords.altitude = position.coords.altitude;
        }
        if ('altitudeAccuracy' in position.coords) {
          positionObject.coords.altitudeAccuracy = position.coords.altitudeAccuracy;
        }
        if ('heading' in position.coords) {
          positionObject.coords.heading = position.coords.heading;
        }
        if ('speed' in position.coords) {
          positionObject.coords.speed = position.coords.speed;
        }
        this.resolve(JSON.stringify(positionObject));
      } else {


        //Failed
        urlMethod(function(error,pos){
          if(!error){
            this.resolve(pos)
          }else{
            this.reject(error)
          }
          

        }.bind({resolve: this.resolve,reject:  this.reject}))
       
        }
      
       
          
      
    }.bind({
      resolve,
      reject,
    }),
    function (err) {
      
      urlMethod(function(error,pos){
        if(!error){
          this.resolve(pos)
        }else{
          this.reject(error)
        }
        

      }.bind({resolve: this.resolve,reject:  this.reject}))

    }.bind({
      resolve,
      reject,
    }), {
      timeout: 6000,
      enableHighAccuracy: true,
    });
  }));
};
